module.exports = __webpack_public_path__ + "img/Documents.2da48dda.svg";